import Cookies from "js-cookie";
import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { isNullOrUndefined } from "util";
import Config from "../../config";
import { dateToString, isDebugMode } from "../../utils";

export interface HttpClient extends AxiosInstance {}

export function createHttpClinet(): HttpClient {
  const httpClient = Axios.create({
    baseURL: Config.baseUrl,
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 15000,
    responseType: "json",
    validateStatus: (status) => status >= 200 && status < 300,
  });

  httpClient.interceptors.request.use((request) => {
    const token = Cookies.get("token");
    if (!isNullOrUndefined(token)) {
      request.headers.Authorization = `Token ${token}`;
    }
    return request;
  });
  if (isDebugMode()) {
    httpClient.interceptors.request.use(logRequest);
    httpClient.interceptors.response.use(logResponse, (error) => {
      logResponse(error.response);
      throw error;
    });
  }
  httpClient.interceptors.response.use(
    (response) => {
      const { status } = response.data;
      if (status === "success") response.data = response.data.data;
      if (status === "fail") response.data = response.data.data;
      if (status === "error") response.data = response.data.message;
      return response;
    },
    (error) => {
      const { response } = error;
      const { status } = response.data;
      if (status === "fail") response.data = response.data.data;
      if (status === "error") response.data = response.data.message;
      throw error;
    }
  );
  return httpClient;
}

function logRequest(request: AxiosRequestConfig): AxiosRequestConfig {
  const { url, baseURL, params, data, headers, method } = request;
  console.log(
    `[${dateToString()}]%c [Http Request]%c\n${method?.toUpperCase()} ${baseURL}${url}`,
    "color: #fff000",
    "",
    "\nparams:",
    params,
    "\ndata:",
    data,
    "\nheaders:",
    headers
  );
  return request;
}

function logResponse(response: AxiosResponse): AxiosResponse {
  const { data, headers, status, config } = response;
  const { method, params, url, baseURL } = config;
  console.log(
    `[${dateToString()}]%c [Http Response]%c\n${method?.toUpperCase()}:${status} ${baseURL}${url}`,
    "color: #fff000",
    "",
    "\nparams:",
    params,
    "\ndata:",
    data,
    "\nheaders:",
    headers
  );
  return response;
}
